import React, {Component} from 'react';
import {useLocation, useParams} from "react-router";
const {useNavigate} = require("react-router");

export const withNavigate = Component => props => {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    return <Component {...props} navigate={navigate} params={params} location={location} />;
};


// WEBPACK FOOTER //
// ./src/WithNavigation.js